import React, { Component } from "react";
import Lottie from "react-lottie";
import { Modal } from "semantic-ui-react";
import * as loading from "assets/animations/letter-loading.json";

export default class LetterLoading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStopped: false,
      isPaused: false,
    };
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: loading.default,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    return (
      <div className="loadingDialog">
        <Modal
          dimmer="blurring"
          open={this.props.isOpen}
          size="mini"
          style={{ background: "transparent", boxShadow: "none" }}
          // onClose={() => dispatch({ type: 'CLOSE_MODAL' })}
        >
          <Modal.Content style={{ background: "transparent" }}>
            <Lottie
              options={defaultOptions}
              height={250}
              width={250}
              isStopped={false}
              isPaused={false}
              isClickToPauseDisabled={true}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}
